import { Controller } from "@hotwired/stimulus";
import { setCurrentHour, setCurrentDay } from "../../utils/calendarUtils";
import * as luxon from "luxon";

export default class extends Controller {
  static targets = [
    "link",
    "formContainer",
    "calendarStyle",
    "horizontalDragPreview",
    "verticalDragPreview",
    "fullLoader",
    "horizontalTestDragPreview",
    "verticalTestDragPreview",
  ];

  connect() {
    // const hourElements = this.element.querySelectorAll(".Calendar-Hour");
    // setCurrentHour(hourElements);
    // const dayElements = this.element.querySelectorAll(".Calendar-WeekDay");
    // setCurrentDay(dayElements);

    console.log("Hello from Stimulus connect!");
  }

  disconnect() {
    this.hideDragPreview();
    this.hideTextAtBottomOfScreen();
    this.hideLoader();
  }

  itemDragged(event) {
    const type =
      (event &&
        event.detail &&
        event.detail.draggedElementAdditionalData &&
        event.detail.draggedElementAdditionalData.type) ||
      "";
    if (type === "lesson") {
      this.lessonDragged(event, "lesson");
    } else if (type === "reserved") {
      this.lessonDragged(event, "reserved slot");
    } else if (type === "slot") {
      this.lessonDragged(event, "slot");
    } else if (type === "slot_uk") {
      this.lessonDragged(event, "slot");
    } else if (type === "test") {
      this.lessonDragged(event, "test");
    } else if (type === "testslot") {
      console.log("Test slot dragged");
      this.testSlotDragged(event, "test slot");
    } else {
      console.log("Unknown type of element");
    }
  }

  itemDropped(event) {
    const type =
      (event &&
        event.detail &&
        event.detail.draggedElementAdditionalData &&
        event.detail.draggedElementAdditionalData.type) ||
      "";
    if (type === "lesson") {
      this.lessonDropped(event);
    } else if (type === "reserved") {
      // this.reservedLessonDropped(event);
    } else if (type === "slot") {
      this.slotDropped(event);
    } else if (type === "slot_uk") {
      this.ukSlotDropped(event, "slot");
    } else if (type === "test") {
      this.lessonDropped(event);
    } else if (type === "testslot") {
      this.testSlotDropped(event, true);
    } else {
      alert("Unknown type of element");
    }
  }

  itemDragEnded(event) {
    this.hideDragPreview();
  }

  testSlotDragged(event) {
    const timezone = this.data.get("timezone") || "Europe/London";

    let newTestTimestamp = event.detail.topY;
    newTestTimestamp = Math.floor(newTestTimestamp / 300) * 300;
    let newEndTimestamp = Math.floor(
      newTestTimestamp +
        event.detail.draggedElementAdditionalData.testDuration * 60
    );
    let newStartTimestamp = Math.floor(
      newTestTimestamp -
        event.detail.draggedElementAdditionalData.lessonDuration * 60
    );

    const newStartTime = luxon.DateTime.fromSeconds(newStartTimestamp, {
      zone: timezone,
    }).toISO();
    const newTestTime = luxon.DateTime.fromSeconds(newTestTimestamp, {
      zone: timezone,
    }).toISO();
    const newEndTime = luxon.DateTime.fromSeconds(newEndTimestamp, {
      zone: timezone,
    }).toISO();

    console.log("HERE!");
    console.log({
      newStartTime,
      newTestTime,
      newEndTime,
    });

    this.moveTestPreview(newStartTime, newTestTime, newEndTime);
  }

  lessonDragged(event, entityType) {
    const timezone = this.data.get("timezone") || "Europe/London";
    let newStartTimestamp = event.detail.topY;
    newStartTimestamp = Math.floor(newStartTimestamp / 300) * 300;
    let newEndTimestamp = Math.floor(
      newStartTimestamp +
        event.detail.draggedElementAdditionalData.durationInMinutes * 60
    );
    const newStartTime = luxon.DateTime.fromSeconds(newStartTimestamp, {
      zone: timezone,
    }).toISO();
    const newEndTime = luxon.DateTime.fromSeconds(newEndTimestamp, {
      zone: timezone,
    }).toISO();

    this.moveDragPreview(newStartTime, newEndTime, entityType);
  }

  async lessonDropped(event) {
    this.hideDragPreview();
    this.showLoader();

    try {
      const csrfToken = document.querySelector(
        'meta[name="csrf-token"]'
      ).content;
      let newStartTimestamp = event.detail.topY;
      newStartTimestamp = Math.floor(newStartTimestamp / 300) * 300;
      const newStartTimeIso = luxon.DateTime.fromSeconds(newStartTimestamp);
      const schoolToken = event.detail.draggedElementAdditionalData.schoolToken;
      const lessonId = event.detail.draggedElementAdditionalData.lessonId;
      const vehicleId = event.detail.draggedElementAdditionalData.vehicleId;
      const durationInMinutes =
        event.detail.draggedElementAdditionalData.durationInMinutes;
      const originalStartTime = luxon.DateTime.fromISO(
        event.detail.draggedElementAdditionalData.originalStartTime
      );
      const originalTestTime = event.detail.draggedElementAdditionalData
        .originalTestTime
        ? luxon.DateTime.fromISO(
            event.detail.draggedElementAdditionalData.originalTestTime
          )
        : null;

      const newStartTime = luxon.DateTime.fromISO(newStartTimeIso);
      let newTestTime = null;
      if (originalTestTime) {
        const startTimeDiff = newStartTime.diff(
          originalStartTime,
          "minutes"
        ).minutes;
        newTestTime = originalTestTime.plus({ minutes: startTimeDiff });
      }

      const originalInstructor =
        event.detail.draggedElementAdditionalData.originalInstructorId;
      if (originalStartTime.toUnixInteger() === newStartTime.toUnixInteger()) {
        this.hideLoader();
        this.hideDragPreview();
        this.hideTextAtBottomOfScreen();
        return;
      }

      const url = `/schools/${schoolToken}/quick-look-edit-lesson`;
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken,
        },
        body: JSON.stringify({
          instructor_id: originalInstructor,
          vehicle_id: vehicleId,
          iso_start_time: newStartTimeIso,
          test_iso_time: newTestTime,
          from_calendar: true,
          lesson_id: lessonId,
          duration_in_minutes: durationInMinutes,
        }),
      });

      if (response.ok) {
        setTimeout(() => {
          this.hideLoader();
          this.hideDragPreview();
          this.hideTextAtBottomOfScreen();
        }, 2000);
      } else {
        alert("Something went wrong, please try again later");
        this.hideLoader();
        this.hideDragPreview();
        this.hideTextAtBottomOfScreen();
      }
    } catch (error) {
      alert("Something went wrong, please try again later");
      this.hideLoader();
      this.hideDragPreview();
      this.hideTextAtBottomOfScreen();
    } finally {
    }
  }

  async ukSlotDropped(event) {
    this.hideDragPreview();
    this.showLoader();

    try {
      const csrfToken = document.querySelector(
        'meta[name="csrf-token"]'
      ).content;
      let newStartTimestamp = event.detail.topY;
      newStartTimestamp = Math.floor(newStartTimestamp / 300) * 300;

      const startTimeIso = luxon.DateTime.fromSeconds(newStartTimestamp);
      const originalStartTime =
        event.detail.draggedElementAdditionalData.originalStartTime;
      const lessonId = event.detail.draggedElementAdditionalData.lessonId;

      const isSameTime =
        startTimeIso.toUnixInteger() ===
        luxon.DateTime.fromISO(originalStartTime).toUnixInteger();
      if (isSameTime) {
        this.hideLoader();
        this.hideDragPreview();
        this.hideTextAtBottomOfScreen();
        return;
      }

      const url = `/pro/web/slot/update`;
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken,
        },
        body: JSON.stringify({
          new_time_iso: startTimeIso,
          lesson_id: lessonId,
        }),
      });

      if (response.ok) {
        setTimeout(() => {
          this.hideLoader();
          this.hideDragPreview();
          this.hideTextAtBottomOfScreen();
        }, 2000);
      } else {
        console.log("Something went wrong, please try again later");
        this.hideLoader();
        this.hideDragPreview();
        this.hideTextAtBottomOfScreen();
      }
    } catch (error) {
      // Stack trace
      console.log(error);
      console.log("Something went wrong, please try again later");
      this.hideLoader();
      this.hideDragPreview();
      this.hideTextAtBottomOfScreen();
    } finally {
    }
  }

  async testSlotDropped(event) {
    this.hideDragPreview();
    this.showLoader();

    try {
      const csrfToken = document.querySelector(
        'meta[name="csrf-token"]'
      ).content;

      let newTestTimestamp = event.detail.topY;
      newTestTimestamp = Math.floor(newTestTimestamp / 300) * 300;
      let newEndTimestamp = Math.floor(
        newTestTimestamp +
          event.detail.draggedElementAdditionalData.testDuration * 60
      );
      let newStartTimestamp = Math.floor(
        newTestTimestamp -
          event.detail.draggedElementAdditionalData.lessonDuration * 60
      );

      const authenticityToken = this.data.get("authenticity");
      const startTimeIso = luxon.DateTime.fromSeconds(newStartTimestamp);
      const originalStartTime =
        event.detail.draggedElementAdditionalData.originalStartTime;
      const originalEndTime =
        event.detail.draggedElementAdditionalData.originalEndTime;
      const vehicleIds = JSON.parse(
        event.detail.draggedElementAdditionalData.vehicleIds || "[]"
      );
      const zoneIds = JSON.parse(
        event.detail.draggedElementAdditionalData.zoneIds || "[]"
      );
      const instructorId =
        event.detail.draggedElementAdditionalData.instructorId;
      const currentStudents =
        event.detail.draggedElementAdditionalData.currentStudents;
      const newStudents = event.detail.draggedElementAdditionalData.newStudents;

      const isSameTime =
        startTimeIso.toUnixInteger() ===
        luxon.DateTime.fromISO(originalStartTime).toUnixInteger();
      const isSameInstructor = true;
      if (isSameTime && isSameInstructor) {
        this.hideLoader();
        this.hideDragPreview();
        this.hideTextAtBottomOfScreen();
        return;
      }

      // Calculate minutes between originalStartTime and originalEndTime
      const originalStartDateTime = luxon.DateTime.fromISO(originalStartTime);
      const originalEndDateTime = luxon.DateTime.fromISO(originalEndTime);
      const originalDurationInMinutes = originalEndDateTime.diff(
        originalStartDateTime,
        "minutes"
      ).minutes;

      const url = `/schools/bookings/update-slot`;
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken,
        },
        body: JSON.stringify({
          authenticity_token: authenticityToken,
          original_start_time: originalStartTime,
          original_end_time: originalEndTime,
          start_time_iso: startTimeIso,
          vehicle_ids: vehicleIds,
          zone_ids: zoneIds,
          instructor_id: instructorId,
          slot_edit_instructor_id: instructorId,
          current_students: currentStudents,
          new_students: newStudents,
          original_instructor_id: instructorId,
          is_test_slot: true,
          duration_in_minutes: originalDurationInMinutes,
        }),
      });

      if (response.ok) {
        setTimeout(() => {
          this.hideLoader();
          this.hideDragPreview();
          this.hideTextAtBottomOfScreen();
        }, 2000);
      } else {
        alert("Something went wrong, please try again later");
        console.log(`Error: ${response.statusText}`);
        this.hideLoader();
        this.hideDragPreview();
        this.hideTextAtBottomOfScreen();
      }
    } catch (error) {
      alert("Something went wrong, please try again later");
      console.error(error);
      this.hideLoader();
      this.hideDragPreview();
      this.hideTextAtBottomOfScreen();
    } finally {
    }
  }

  async slotDropped(event) {
    this.hideDragPreview();
    this.showLoader();

    try {
      const csrfToken = document.querySelector(
        'meta[name="csrf-token"]'
      ).content;
      let newStartTimestamp = event.detail.topY;
      newStartTimestamp = Math.floor(newStartTimestamp / 300) * 300;

      const authenticityToken = this.data.get("authenticity");

      const startTimeIso = luxon.DateTime.fromSeconds(newStartTimestamp);
      const originalStartTime =
        event.detail.draggedElementAdditionalData.originalStartTime;
      const originalEndTime =
        event.detail.draggedElementAdditionalData.originalEndTime;
      const vehicleIds = JSON.parse(
        event.detail.draggedElementAdditionalData.vehicleIds || "[]"
      );
      const zoneIds = JSON.parse(
        event.detail.draggedElementAdditionalData.zoneIds || "[]"
      );
      const instructorId =
        event.detail.draggedElementAdditionalData.instructorId;
      const currentStudents =
        event.detail.draggedElementAdditionalData.currentStudents;
      const newStudents = event.detail.draggedElementAdditionalData.newStudents;

      // Yeet
      const tags = event.detail.draggedElementAdditionalData.tags.split(",");
      const durationInMinutes =
        parseInt(event.detail.draggedElementAdditionalData.durationInMinutes);
      const duration =
        parseInt(event.detail.draggedElementAdditionalData.duration);
      const allowObservers =
        event.detail.draggedElementAdditionalData.observable;
      const allowProgramlessTeens = tags.includes("program_teen");
      const allowProgramlessAdults = tags.includes("program_adult");
      const programObject = {}
      tags.forEach((tag) => {
        if (tag.startsWith("program_") && tag !== "program_teen" && tag !== "program_adult") {
          const programId = tag.replace("program_", "");
          programObject[`allow_program_${programId}`] = true;
        }
        if(tag.startsWith("classroom_program_")) {
          const programId = tag.replace("classroom_program_", "");
          programObject[`allow_classroom_program_${programId}`] = true;
        }
      });
      if(allowObservers === 'true') {
        programObject['allow_observers'] = true;
      }
      if(allowProgramlessTeens) {
        programObject['allow_programless_teens'] = true;
      }
      if(allowProgramlessAdults) {
        programObject['allow_programless_adults'] = true;
      }
      programObject['duration'] = duration;

      const isSameTime =
        startTimeIso.toUnixInteger() ===
        luxon.DateTime.fromISO(originalStartTime).toUnixInteger();
      if (isSameTime) {
        this.hideLoader();
        this.hideDragPreview();
        this.hideTextAtBottomOfScreen();
        return;
      }

      const url = `/schools/bookings/update-slot`;
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken,
        },
        body: JSON.stringify({
          original_start_time: originalStartTime,
          original_end_time: originalEndTime,
          start_time_iso: startTimeIso,
          vehicle_ids: vehicleIds,
          zone_ids: zoneIds,
          instructor_id: instructorId,
          slot_edit_instructor_id: instructorId,
          current_students: currentStudents,
          new_students: newStudents,
          original_instructor_id: instructorId,
          duration_in_minutes: durationInMinutes,
          ...programObject,
        }),
      });

      if (response.ok) {
        setTimeout(() => {
          this.hideLoader();
          this.hideDragPreview();
          this.hideTextAtBottomOfScreen();
        }, 2000);
      } else {
        console.log("Something went wrong, please try again later");
        this.hideLoader();
        this.hideDragPreview();
        this.hideTextAtBottomOfScreen();
      }
    } catch (error) {
      // Stack trace
      console.log(error);

      console.log("Something went wrong, please try again later");
      this.hideLoader();
      this.hideDragPreview();
      this.hideTextAtBottomOfScreen();
    } finally {
    }
  }

  hideDragPreview() {
    this.hideTextAtBottomOfScreen();
    if (this.hasHorizontalDragPreviewTarget) {
      const dragPreview = this.horizontalDragPreviewTarget;
      dragPreview.classList.add("u-hidden");
    }
    if (this.hasHorizontalTestDragPreviewTarget) {
      const testDragPreview = this.horizontalTestDragPreviewTarget;
      testDragPreview.classList.add("u-hidden");
    }
  }

  moveTestDragPreview(startTimeIso, endTimeIso, entityType) {
    const timeZone = this.data.get("timezone") || "Europe/London";
    if (!this.hasHorizontalTestDragPreviewTarget) return;
    const dragPreview = this.horizontalTestDragPreviewTarget;
    if (!dragPreview) return;
    const startDateTime =
      luxon.DateTime.fromISO(startTimeIso).setZone(timeZone);
    const endDateTime = luxon.DateTime.fromISO(endTimeIso).setZone(timeZone);
    const durationInMinutes = endDateTime.diff(
      startDateTime,
      "minutes"
    ).minutes;
    const startHours = startDateTime.toFormat("hha").toLowerCase();
    const startMins = startDateTime.toFormat("mm").toLowerCase();
    const endHours = endDateTime.toFormat("hha").toLowerCase();
    const endMins = endDateTime.toFormat("mm").toLowerCase();
    // eed to set the day of week e.g. mon, tue, wed etc.
    const dayOfWeek = startDateTime.toFormat("ccc").toLowerCase();
    dragPreview.dataset.timeHours = startHours;
    dragPreview.dataset.timeMins = startMins;
    dragPreview.dataset.duration = durationInMinutes;
    dragPreview.dataset.day = dayOfWeek;
    dragPreview.classList.remove("u-hidden");
  }

  moveTestPreview(startTimeIso, testTimeIso, endTimeIso) {
    const timeZone = this.data.get("timezone") || "Europe/London";

    const dragPreview = this.horizontalDragPreviewTarget;
    const dragTestPreview = this.horizontalTestDragPreviewTarget;
    if (!dragPreview || !dragTestPreview) return;

    const startDateTime =
      luxon.DateTime.fromISO(startTimeIso).setZone(timeZone);
    const testDateTime = luxon.DateTime.fromISO(testTimeIso).setZone(timeZone);
    const endDateTime = luxon.DateTime.fromISO(endTimeIso).setZone(timeZone);

    const lessonDuration = testDateTime.diff(startDateTime, "minutes").minutes;
    const testDuration = endDateTime.diff(testDateTime, "minutes").minutes;

    const startHours = startDateTime.toFormat("hha").toLowerCase();
    const startMins = startDateTime.toFormat("mm").toLowerCase();
    const testHours = testDateTime.toFormat("hha").toLowerCase();
    const testMins = testDateTime.toFormat("mm").toLowerCase();
    const dayOfWeek = startDateTime.toFormat("ccc").toLowerCase();

    dragPreview.dataset.timeHours = startHours;
    dragPreview.dataset.timeMins = startMins;
    dragPreview.dataset.duration = lessonDuration;
    dragPreview.dataset.day = dayOfWeek;
    dragPreview.classList.remove("u-hidden");

    dragTestPreview.dataset.timeHours = testHours;
    dragTestPreview.dataset.timeMins = testMins;
    dragTestPreview.dataset.duration = testDuration;
    dragTestPreview.dataset.day = dayOfWeek;
    dragTestPreview.classList.remove("u-hidden");

    this.displayTextAtBottomOfScreen(
      `Move test to ${testDateTime.toFormat("h:mma")} - ${endDateTime.toFormat(
        "h:mma"
      )} (pretest lesson starts at ${startDateTime.toFormat("h:mma")})`
    );
  }

  moveDragPreview(startTimeIso, endTimeIso, entityType) {
    const timeZone = this.data.get("timezone") || "Europe/London";
    console.log("moveDragPreview", startTimeIso, endTimeIso, entityType);
    if (!this.hasHorizontalDragPreviewTarget) return;
    const dragPreview = this.horizontalDragPreviewTarget;
    if (!dragPreview) return;
    const startDateTime =
      luxon.DateTime.fromISO(startTimeIso).setZone(timeZone);
    const endDateTime = luxon.DateTime.fromISO(endTimeIso).setZone(timeZone);
    const durationInMinutes = endDateTime.diff(
      startDateTime,
      "minutes"
    ).minutes;
    const startHours = startDateTime.toFormat("hha").toLowerCase();
    const startMins = startDateTime.toFormat("mm").toLowerCase();
    const endHours = endDateTime.toFormat("hha").toLowerCase();
    const endMins = endDateTime.toFormat("mm").toLowerCase();
    // eed to set the day of week e.g. mon, tue, wed etc.
    const dayOfWeek = startDateTime.toFormat("ccc").toLowerCase();

    dragPreview.dataset.timeHours = startHours;
    dragPreview.dataset.timeMins = startMins;
    dragPreview.dataset.duration = durationInMinutes;
    dragPreview.dataset.day = dayOfWeek;
    dragPreview.classList.remove("u-hidden");
    this.displayTextAtBottomOfScreen(
      `Move ${entityType} to ${startDateTime.toFormat(
        "h:mma"
      )} - ${endDateTime.toFormat("h:mma")}`
    );
  }

  panelId = `${Math.random().toString(36).substring(7)}`;
  displayTextAtBottomOfScreen(text) {
    // Create the panel and animate upwards if necessary
    let panel = document.getElementById(this.panelId);
    if (!panel) {
      panel = document.createElement("div");
      panel.id = this.panelId;
      panel.style.position = "fixed";
      panel.style.bottom = "0";
      panel.style.left = "0";
      panel.style.width = "100%";
      panel.style.backgroundColor = "#FEFAE3";
      panel.style.padding = "10px";
      panel.style.textAlign = "center";
      panel.style.zIndex = "5";
      panel.style.borderTop = "1px solid #EFDE43";
      // Panel should animate offscreen
      panel.style.transform = "translateY(100%)";
      panel.style.transition = "transform 0.5s";
      document.body.appendChild(panel);
    }

    setTimeout(() => {
      panel.style.transform = "translateY(0)";
    });
    panel.textContent = text;
  }

  hideTextAtBottomOfScreen() {
    const panel = document.getElementById(this.panelId);
    if (!panel) return;
    panel.style.transform = "translateY(100%)";
  }

  showLoader() {
    // Set display to flex
    if (!this.hasFullLoaderTarget) return;
    this.fullLoaderTarget.style.display = "flex";
  }

  hideLoader() {
    // Set display to none
    if (!this.hasFullLoaderTarget) return;
    this.fullLoaderTarget.style.display = "none";
  }
}
